module.exports = __webpack_public_path__ + "img/usuario.642909fe.svg";